// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__ToC2F","error":"Textarea_error__3tyXX","readonly":"Textarea_readonly__3SvGD","disabled":"Textarea_disabled__RZkHB"};